// extracted by mini-css-extract-plugin
export default {"weightKeyboard":"check_weightKeyboard__5sbN9"};